<template>
    <div class="flex h-full min-h-dvh w-full flex-col">
        <router-view></router-view>
    </div>
</template>

<script>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { callApi } from "@/scripts/useFetch.js";
import { useWebStore, useUserStore } from "@/stores/userStore.js";
import { loadScript } from "./scripts/utils/domUtils";
import { configure } from "vue-gtag";
import Cookies from "js-cookie";
import bg from "@/assets/bg.svg";

export default {
    name: "App",
    setup() {
        // console.log(process.env.NODE_ENV);
        // const route = useRoute();
        const router = useRouter();
        const userStore = useUserStore();
        const webStore = useWebStore();

        const updateMobileOrientationClass = () => {
            const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
            webStore.setIsMobile(isMobile);
            // console.log("updateMobileOrientationClass in", isMobile);
            if (isMobile) {
                document.documentElement.classList.add("is-mobile");
                document.documentElement.classList.remove("is-pc");
            } else {
                document.documentElement.classList.remove("is-mobile");
                document.documentElement.classList.add("is-pc");
            }
        };
        window.addEventListener("resize", updateMobileOrientationClass);
        window.addEventListener("orientationchange", updateMobileOrientationClass);
        window.addEventListener("DOMContentLoaded", updateMobileOrientationClass);

        const currentUser = ref(null);
        const currentGAID = ref(null);

        router.beforeEach((to) => {
            if (!to.name) {
                return;
            }
            //只有Widget不放背景圖，因為他需要被放在OBS，背景透明
            document.body.style.backgroundImage = to.name.startsWith("Widget.") ? "" : `url(${bg})`;
            callApi("Post", "/Member/AnonymousMapping").then((json) => {
                if (!json.Success) {
                    Cookies.remove(process.env.VUE_APP_AnonymousID);
                }
            });
            const isBackend = to.name.startsWith("Backend") || to.name.startsWith("Widget") || to.name.startsWith("Landing");
            const inspectlet = process.env.VUE_APP_Inspectlet;
            if (isBackend && inspectlet) {
                loadScript(inspectlet);
            }
            //權限檢查
            callApi("Get", `/Auth/CheckAuth?From=${to.name}`)
                .then((json) => {
                    checkLogin(json.IsAuthenticated, to);
                })
                .catch((response) => {
                    // if (response.status == 401) {
                    checkLogin(false, to);
                    // }
                });
        });
        // 前後台使用不同的GA ID
        router.afterEach((to) => {
            if (!to.name) {
                return;
            }
            const isBackend = to.name.startsWith("Backend") || to.name.startsWith("Widget");
            const isFront = to.name.startsWith("FrontEnd") || to.name.startsWith("Landing") || to.name.startsWith("DiscordAuthCallback");
            const gaid = {
                front: process.env.VUE_APP_GAID_Front,
                back: process.env.VUE_APP_GAID_Back,
                default: process.env.VUE_APP_GAID,
            };
            if (isFront && gaid.front) {
                currentGAID.value = gaid.front;
            } else if (isBackend && gaid.back) {
                currentGAID.value = gaid.back;
            } else {
                currentGAID.value = gaid.default;
            }
        });

        const checkLogin = (isLogin, route) => {
            if (isLogin) {
                if (route.meta.loginDirect) {
                    router.push({ name: route.meta.loginDirect });
                } else {
                    callApi("Get", "/Member/GetAccountInfo").then((json) => {
                        if (json.Success) {
                            userStore.setUserInfo(json);
                            currentUser.value = json.AccountID;
                        }
                    });
                }
            } else {
                userStore.setUserInfo({});
                if (route.meta.loginPage && route.meta.needLogin) {
                    router.push({ name: route.meta.loginPage });
                } else {
                    currentUser.value = 0;
                }
            }
        };

        watch(
            [() => currentUser.value, () => currentGAID.value],
            () => {
                if (currentGAID.value != null && currentUser.value != null) {
                    if (currentUser.value > 0) {
                        configure({
                            tagId: currentGAID.value,
                            config: {
                                user_id: `user_${currentUser.value}`,
                            },
                        });
                    } else {
                        configure({
                            tagId: currentGAID.value,
                        });
                    }
                }
            },
            { immediate: true },
        );
    },
};
</script>
